// extracted by mini-css-extract-plugin
export var button = "_b0-4";
export var hasDarkBackground = "_b0-7";
export var hasLightBackground = "_b0-6";
export var iconWrapper = "_b0-0";
export var large = "_b0-2";
export var medium = "_b0-1";
export var small = "_b0-5";
export var xsmall = "_b0-3";